<template>
  <div data-module="intro">
    <div class="main">
      <h1>{{data.title}}</h1>
      <div class="content">
        <markdown class="markdown">{{data.content}}</markdown>
      </div>
    </div>
    <div class="aside">
      <div class="aside__grid">
        <div class="aside__content">
          <h2>Our role</h2>
          <ul class="roles">
            <li v-for="role in data.roles" class="role" :key="role">
              {{role}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'module_intro',
  props: ['data'],
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

$mobile-breakpoint: $breakpoint--default-mobile;

[data-module="intro"] {
  @include spacer();
  @include grid($subgrid: true);

  .main {
    grid-column: 1 / span 7;
    margin-top: rem(-100px);

    background: white;
    padding: rem(50px) 4rem 0 4rem;

    h1 {
      @include type('article-heading');
    }
  }

  .aside {
    grid-column: 9 / span 4;
    background: #ccc;
    align-self: flex-start;

    h2 {
      @include type('article-aside-heading');
    }
  }

  .aside__grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-gap: 0 #{$layout--gutter * 1};
    margin-top: 4.5rem;
    @include spacer();
  }

  .aside__content {
    grid-column: 2 / span 6;
  }

  .roles {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .role {
    margin: 0 0 0.5em 0;
    line-height: 1.33;
    padding: 0.25rem 0;
  }

  @include mq($bp--tablet, 'down') {
    [data-module="intro"] {
      grid-template-rows: auto auto;
      margin: 0 0 2rem 0;
    }

    .main {
      grid-column: 1 / span 12;
      grid-row: 1 / span 1;
      margin-bottom: 2rem;
      @include spacer();
    }

    .aside {
      grid-column: 1 / -1;
      grid-row: 2 / span 2;
      // background: transparent;
      margin: 0;
    }

    .aside__content {
      grid-column: 1 / span 12;
      padding: 2rem;
    }

    .aside__grid {
      margin: 0;
    }

    .main h1 {
      @include type($name: 'article-heading', $viewport: 'mobile');
    }
  }

  @include mq($bp--mobile, down) {
    .main {
      margin-top: 0;
      padding: 2rem 0 0 0;
    }

    .aside {
      grid-column: 1 / -1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/intro.vue